import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const internalJobsApi = createApi({
  reducerPath: 'internalJobsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    // Endpoint pre list vsetkych Fakultnych praxi (CMS - requires authentication)
    getInternalJobs: builder.query({
      query: () => ({
        url: urls.fijJobs,
      }),
    }),
    // Endpoint pre list Fakultnych praxi (Public - no authentication required)
    getInternalJobsPublic: builder.query({
      query: () => ({
        url: urls.fijJobsPublic,
      }),
    }),
    getInternalJob: builder.query({
      query(arg) {
        const id = typeof arg === 'object' ? arg.id : arg;
        const forDetail = typeof arg === 'object' ? arg.forDetail : undefined;
        return {
          url: urls.fijJobDetail(id),
          method: 'GET',
          params: forDetail ? { forDetail } : {},
        };
      },
    }),
    getInterns: builder.query({
      query(id) {
        return {
          url: urls.fijJobInterns(id),
          method: 'GET',
        };
      },
    }),
    approveInternalJob: builder.mutation({
      query(id) {
        return {
          url: urls.fijJobApprove(id),
          method: 'POST',
        };
      },
    }),
    rejectInternalJob: builder.mutation({
      query(id) {
        return {
          url: urls.fijJobReject(id),
          method: 'POST',
        };
      },
    }),
    archiveInternalJob: builder.mutation({
      query(id) {
        return {
          url: urls.fijJobArchive(id),
          method: 'POST',
        };
      },
    }),
    restoreInternalJob: builder.mutation({
      query({ id, autoApprove }) {
        return {
          url: urls.fijJobRestore(id),
          method: 'POST',
          params: autoApprove ? { auto_approve: 1 } : undefined,
        };
      },
    }),
    saveInternalJob: builder.mutation({
      query(req) {
        const { body, id } = req;
        const payload = {
          ...body,
          date_from: body?.date_from?.format
            ? body.date_from.format('YYYY-MM-DD')
            : body?.date_from,
          date_to: body?.date_to?.format
            ? body.date_to.format('YYYY-MM-DD')
            : body?.date_to,
        };

        if (id) {
          return {
            url: urls.fijJobDetail(id),
            method: 'PUT',
            data: payload,
          };
        } else {
          return {
            url: urls.fijJobs,
            method: 'POST',
            data: payload,
          };
        }
      },
    }),
    deleteInternalJob: builder.mutation({
      query(id) {
        return {
          url: urls.fijJobDetail(id),
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useGetInternalJobsQuery,
  useGetInternalJobsPublicQuery,
  useGetInternalJobQuery,
  useGetInternsQuery,
  useSaveInternalJobMutation,
  useDeleteInternalJobMutation,
  useApproveInternalJobMutation,
  useRejectInternalJobMutation,
  useArchiveInternalJobMutation,
  useRestoreInternalJobMutation,
} = internalJobsApi;
